import { render, staticRenderFns } from "./traveler-icon.vue?vue&type=template&id=dfbea4d2"
import script from "./traveler-icon.vue?vue&type=script&lang=js"
export * from "./traveler-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports